export const smallTalkIntent = 'smalltalk.'
